import { FEDERAL_2026 } from '../data/federal-2026';

interface DeductionsStepProps {
  retirement401k: number;
  hsaContribution: number;
  studentLoanInterest: number;
  onChangeRetirement: (next: number) => void;
  onChangeHsa: (next: number) => void;
  onChangeStudentLoan: (next: number) => void;
}

const moneyField = (
  label: string,
  help: string,
  value: number,
  onChange: (next: number) => void,
) => (
  <div>
    <label className="block text-sm font-medium text-slate-900">{label}</label>
    <p className="mt-1 text-xs text-slate-500">{help}</p>
    <div className="relative mt-2">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
        $
      </span>
      <input
        type="number"
        inputMode="decimal"
        min={0}
        step={1}
        value={Number.isFinite(value) ? value : 0}
        onChange={(e) => {
          const v = e.target.value === '' ? 0 : Number(e.target.value);
          if (Number.isFinite(v) && v >= 0) onChange(v);
        }}
        className="w-full rounded-md border border-slate-300 py-2.5 pl-7 pr-4 font-mono text-base focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-200"
      />
    </div>
  </div>
);

export function DeductionsStep({
  retirement401k,
  hsaContribution,
  studentLoanInterest,
  onChangeRetirement,
  onChangeHsa,
  onChangeStudentLoan,
}: DeductionsStepProps) {
  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-base font-medium text-slate-900">
          Above-the-line deductions
        </h3>
        <p className="mt-1 text-sm text-slate-500">
          These reduce your AGI before tax brackets are applied. Leave any
          field at 0 if it doesn't apply.
        </p>
      </div>
      {moneyField(
        '401(k) / 403(b) contribution',
        'Employee deferral (not employer match) for the tax year.',
        retirement401k,
        onChangeRetirement,
      )}
      {moneyField(
        'HSA contribution',
        'Out-of-pocket contributions to a Health Savings Account.',
        hsaContribution,
        onChangeHsa,
      )}
      {moneyField(
        'Student loan interest paid',
        `Deductible up to $${FEDERAL_2026.studentLoanInterestMax.toLocaleString()}. We cap it for you.`,
        studentLoanInterest,
        onChangeStudentLoan,
      )}
    </div>
  );
}